import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { User } from './user.interface';

export class UserService {
   async getUsers(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<User>>>(`/users`, { params: { ...query } });
      return response.data;
   }
   async getUser(userId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<User>>(`/users/${userId}`, { params: { ...query } });
      return response.data;
   }
}
